import { itemDocSerializer } from "@megaron/catalog-contracts";
import { HttpAction } from "@megaron/http-service";
import { Serializers } from "@megaron/serializers";

export const itemsSortFields = ["box", "pallet", "layer", "size", "gtin"] as const;
export type ItemSortField = (typeof itemsSortFields)[number];

export const itemActions = {
  searchItems: HttpAction({
    path: "/items",
    qsSerializer: Serializers.object({
      searchText: Serializers.string,
      sort: Serializers.sortFilter(itemsSortFields).asJsonString(),
      isLoyalty: Serializers.jsonString(Serializers.boolean),
      groups: Serializers.jsonString(Serializers.array(Serializers.string)),
      isArchived: Serializers.jsonString(Serializers.boolean),
      isInAvailability: Serializers.jsonString(Serializers.boolean),
    }).partial(),
    valueSerializer: Serializers.paginatedList(itemDocSerializer),
    requiresAuth: true,
  }),

  searchProductGroups: HttpAction({
    path: "/items/productsGroups",
    qsSerializer: Serializers.object({
      searchText: Serializers.string,
    }).partial(),
    valueSerializer: Serializers.string.array(),
    requiresAuth: true,
  }),

  searchProductIds: HttpAction({
    path: "/items/productsIds",
    qsSerializer: Serializers.object({
      searchText: Serializers.string,
      isArchived: Serializers.jsonString(Serializers.boolean),
    }).partial(),
    valueSerializer: Serializers.string.array(),
    requiresAuth: true,
  }),
};
